// extracted by css-extract-rspack-plugin
export default {"row_tr":"krhqFHPjGUskqBH6","with_btn":"FIJB6aHp8A6pvB20","cont":"MkVgzE4caIkn9Inq","btn_view":"Wu5ZZVWcB4Zvdden","active":"wJN4mCylrXUS3ywj","withChbx":"DntcV17I5h8gXCzo"};